import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Collapse, Row, Spinner } from "react-bootstrap";
import {
  saveLeadAddress,
  fetchAddressAutocompleteOptions
} from "../../services/api";
import AsyncSelectField from "../AsyncSelect";
import ValidationMessage from "../ValidationMessage";
import { updateLeadId } from "../../store/slices/funnelInfo";
import { AddressSchema } from "../../services/validation-schema";

const AddressForm = () => {
  const dispatch = useDispatch();
  const funnelInfo = useSelector((state) => state.funnelInfo);
  const {
    leadForm: { leadId },
    funnel
  } = funnelInfo;
  const thankyouPage = funnel.thankyouPage;
  const baseColor = funnel.design?.baseColor;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  const methods = useForm({
    defaultValues: { address: { description: "" } }, // address as object because async-select returns object
    resolver: yupResolver(AddressSchema)
  });
  const {
    handleSubmit,
    formState: { errors }
  } = methods;

  const fetchAutocompleteOptions = async (value) => {
    try {
      if (value?.queryText) {
        const response = await fetchAddressAutocompleteOptions(value.queryText);
        return response.data.data.predictions;
      }
    } catch (err) {
      console.log("Error in fetch address options: ", err);
    }
  };
  const onSubmit = async (values) => {
    setIsSubmitting(true);
    const { description, place_id } = values.address;
    try {
      await saveLeadAddress(leadId, {
        description,
        placeId: place_id,
        funnel: { id: funnel._id, type: funnel.general.funnelType }
      });
      dispatch(updateLeadId(null));
      setIsSubmitSuccessful(true);
    } catch (error) {
      console.error("Error updating lead address:", error);
      setIsSubmitSuccessful(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(updateLeadId(null));
    };
  }, [dispatch]);

  return (
    <>
      {!isSubmitSuccessful && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} className="text-start">
            <Row className="align-items-center">
              <Col sm={12}>
                <label className={errors.address ? "text-danger" : ""}>
                  {thankyouPage.addressLabel}:
                </label>
                <AsyncSelectField
                  name="address"
                  paramName="queryText"
                  optionLabel="description"
                  optionValue="description"
                  fieldError={errors.address}
                  fetchData={fetchAutocompleteOptions}
                />
                {errors.address?.description && (
                  <ValidationMessage
                    message={errors.address.description.message}
                  />
                )}
                <div className="text-center mt-3">
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-100 fw-bold border-0 outline-0"
                    style={{ backgroundColor: baseColor }}
                  >
                    {isSubmitting && (
                      <Spinner size="sm" className="me-2" animation="border" />
                    )}
                    {thankyouPage?.addressSubmitButtonLabel}
                  </Button>
                </div>
              </Col>
            </Row>
          </form>
        </FormProvider>
      )}
      <Collapse in={isSubmitSuccessful}>
        <div>
          <div className="d-flex align-items-center justify-content-center bg-success text-white py-3 rounded">
            <FontAwesomeIcon icon={faCheckCircle} size="lg" className="me-2" />
            <div>Die Adresse wurde erfolgreich weitergeleitet</div>
          </div>
        </div>
      </Collapse>
    </>
  );
};
export default AddressForm;
